<span class="ctry">
	<img
		*ngIf="iso2Resolved && hasName && !flagError"
		class="ctry-flag"
		[src]="flagSrc"
		alt=""
		loading="lazy"
		(error)="flagError = true"
	/>
	<span class="ctry-name">{{ hasName ? name : empty }}</span>
</span>
